import { useToast } from "@adafia/ui";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteNote } from "@/notes/api/notes";

export const useDeleteNode = (onSuccess?: (id: string) => void) => {
	const queryClient = useQueryClient();
	const { showToast } = useToast();

	return useMutation({
		mutationFn: (id: string) => deleteNote(id),
		onSuccess: (_data, id) => {
			queryClient.invalidateQueries({ queryKey: ["tree"] });
			queryClient.invalidateQueries({ queryKey: ["getNode", id] });
			onSuccess?.(id);
		},
		onError: (error: Error) => {
			showToast(error.message || "Failed to delete note", "error");
		},
	});
};
